(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["brew-steps"] && !Shopify.designMode) return;
  try {
    
  // Lazy-attach and play brew-step loops only while they're on screen.
  // A custom element (rather than a one-off script) so it re-initialises
  // when the theme editor re-renders the section.
  if (!customElements.get('brew-steps-grid')) {
    customElements.define(
      'brew-steps-grid',
      class BrewStepsGrid extends HTMLElement {
        connectedCallback() {
          const videos = this.querySelectorAll('.brew-steps__video[data-src]');
          if (!videos.length) return;

          // Reduced motion: leave the posters as static images.
          if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

          if (!('IntersectionObserver' in window)) {
            videos.forEach((v) => this.start(v));
            return;
          }

          this.observer = new IntersectionObserver(
            (entries) => {
              for (const entry of entries) {
                const v = entry.target;
                if (entry.isIntersecting) {
                  this.start(v);
                } else if (v.getAttribute('src')) {
                  v.pause();
                }
              }
            },
            { rootMargin: '200px 0px' }
          );
          videos.forEach((v) => this.observer.observe(v));
        }

        disconnectedCallback() {
          this.observer?.disconnect();
        }

        start(v) {
          if (!v.getAttribute('src')) v.src = v.dataset.src;
          v.play().catch(() => {});
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cultivar-product-grid"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (customElements.get('cultivar-carousel')) return;

  class CultivarCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-cv-track]');
      if (!this.track) return;

      this.prevBtn = this.querySelector('[data-cv-prev]');
      this.nextBtn = this.querySelector('[data-cv-next]');
      this.bar = this.querySelector('[data-cv-progress-bar]');
      this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

      this._onScroll = () => {
        if (this._raf) return;
        this._raf = requestAnimationFrame(() => {
          this._raf = null;
          this.update();
        });
      };
      this._onPrev = () => this.go(-1);
      this._onNext = () => this.go(1);
      this._onKey = (e) => {
        if (e.target !== this.track) return;
        if (e.key === 'ArrowLeft') { e.preventDefault(); this.go(-1); }
        if (e.key === 'ArrowRight') { e.preventDefault(); this.go(1); }
      };

      this.track.addEventListener('scroll', this._onScroll, { passive: true });
      this.track.addEventListener('keydown', this._onKey);
      if (this.prevBtn) this.prevBtn.addEventListener('click', this._onPrev);
      if (this.nextBtn) this.nextBtn.addEventListener('click', this._onNext);

      if ('ResizeObserver' in window) {
        this._ro = new ResizeObserver(this._onScroll);
        this._ro.observe(this.track);
      } else {
        window.addEventListener('resize', this._onScroll);
      }

      // Images loading can change scrollWidth
      this.track.querySelectorAll('img').forEach((img) => {
        if (!img.complete) img.addEventListener('load', this._onScroll, { once: true });
      });

      // First measurement on the next frame: calling update() here read scrollWidth/clientWidth
      // synchronously and forced a full-page layout before the hero could paint.
      this._onScroll();
    }

    disconnectedCallback() {
      if (!this.track) return;
      this.track.removeEventListener('scroll', this._onScroll);
      this.track.removeEventListener('keydown', this._onKey);
      if (this.prevBtn) this.prevBtn.removeEventListener('click', this._onPrev);
      if (this.nextBtn) this.nextBtn.removeEventListener('click', this._onNext);
      if (this._ro) this._ro.disconnect();
      else window.removeEventListener('resize', this._onScroll);
      if (this._raf) cancelAnimationFrame(this._raf);
    }

    // Scroll one "page" — however many whole cards are currently in view
    stepSize() {
      const slide = this.track.querySelector('[data-cv-slide]');
      if (!slide) return this.track.clientWidth;
      const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      const slideStep = slide.getBoundingClientRect().width + gap;
      const perView = Math.max(1, Math.floor((this.track.clientWidth + gap) / slideStep + 0.01));
      return slideStep * perView;
    }

    go(dir) {
      this.track.scrollBy({
        left: dir * this.stepSize(),
        behavior: this.reduceMotion.matches ? 'auto' : 'smooth'
      });
    }

    update() {
      const t = this.track;
      const max = t.scrollWidth - t.clientWidth;
      const pos = Math.abs(t.scrollLeft);
      const scrollable = max > 2;

      this.classList.toggle('is-scrollable', scrollable);
      if (this.prevBtn) this.prevBtn.disabled = !scrollable || pos <= 2;
      if (this.nextBtn) this.nextBtn.disabled = !scrollable || pos >= max - 2;

      if (this.bar) {
        const ratio = t.scrollWidth > 0 ? t.clientWidth / t.scrollWidth : 1;
        const progress = scrollable ? pos / max : 0;
        this.bar.style.width = (ratio * 100) + '%';
        this.bar.style.transform = 'translateX(' + (progress * (1 / ratio - 1) * 100) + '%)';
      }
    }
  }

  customElements.define('cultivar-carousel', CultivarCarousel);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-collection-product-grid"] && !Shopify.designMode) return;
  try {
    
(function() {

  // ── Sort: auto-submit on change ──
  document.querySelectorAll('.toolbar-sort__select').forEach(function(select) {
    select.addEventListener('change', function() {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', this.value);
      window.location.href = url.toString();
    });
  });

  // ── Filter drawer toggle ──
  document.querySelectorAll('.toolbar-btn--filters').forEach(function(btn) {
    var drawerId = btn.getAttribute('aria-controls');
    var drawer   = document.getElementById(drawerId);
    if (!drawer) return;

    btn.addEventListener('click', function() {
      var isOpen = this.getAttribute('aria-expanded') === 'true';
      this.setAttribute('aria-expanded', String(!isOpen));
      drawer.setAttribute('aria-hidden', String(isOpen));
    });
  });

  // ── Filter group collapse toggles ──
  document.querySelectorAll('.cg-filter-group__toggle').forEach(function(toggle) {
    toggle.addEventListener('click', function() {
      var isExpanded = this.getAttribute('aria-expanded') === 'true';
      var panelId    = this.getAttribute('aria-controls');
      var panel      = document.getElementById(panelId);
      this.setAttribute('aria-expanded', String(!isExpanded));
      if (panel) {
        if (isExpanded) { panel.setAttribute('hidden', ''); }
        else            { panel.removeAttribute('hidden'); }
      }
    });
  });

// ── Collection description: collapsible if overflows ──
document.querySelectorAll('[data-collapsible]').forEach(function(wrap) {
  var content = wrap.querySelector('[data-collapsible-content]');
  var toggle  = wrap.querySelector('[data-collapsible-toggle]');
  if (!content || !toggle) return;

  var checkOverflow = function() {
    if (wrap.classList.contains('is-expanded')) return;
    var overflows = content.scrollHeight > content.clientHeight + 2;
    toggle.hidden = !overflows;
  };

  // Initial measurement — wait for fonts if the API is available,
  // otherwise fall back to a delayed check.
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(checkOverflow);
  } else {
    setTimeout(checkOverflow, 300);
  }
  // Also do an immediate check in case fonts are already loaded from cache
  requestAnimationFrame(checkOverflow);

  // Re-check whenever the container resizes (viewport, layout shifts)
  if ('ResizeObserver' in window) {
    var ro = new ResizeObserver(function() { checkOverflow(); });
    ro.observe(content);
  } else {
    window.addEventListener('resize', function() {
      clearTimeout(wrap._cgTimer);
      wrap._cgTimer = setTimeout(checkOverflow, 150);
    });
  }

  toggle.addEventListener('click', function() {
    var expanded = wrap.classList.toggle('is-expanded');
    toggle.setAttribute('aria-expanded', String(expanded));
  });
});

  // ── Filter form: submit navigates to filtered URL ──
  document.querySelectorAll('.cg-filter-form').forEach(function(form) {
    form.addEventListener('submit', function(e) {
      e.preventDefault();
      var params   = new URLSearchParams();
      var formData = new FormData(form);

      // Checked checkboxes
      form.querySelectorAll('input[type="checkbox"]:checked').forEach(function(cb) {
        params.append(cb.name, cb.value);
      });
      // Price inputs
      form.querySelectorAll('input[type="number"]').forEach(function(inp) {
        if (inp.value !== '') params.set(inp.name, inp.value);
      });
      // sort_by
      var sortInput = form.querySelector('input[name="sort_by"]');
      if (sortInput && sortInput.value) params.set('sort_by', sortInput.value);

      window.location.href = window.location.pathname + '?' + params.toString();
    });
  });

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-slideshow"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('custom-slideshow')) return;

    class CustomSlideshow extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-slides]');
        if (!this.track) return;

        this.dots = Array.from(this.querySelectorAll('[data-dot]'));
        this.count = this.track.children.length;
        this.index = 0;
        this.loop = this.hasAttribute('data-loop');
        this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        this.handleScroll = this.handleScroll.bind(this);
        this.track.addEventListener('scroll', this.handleScroll, { passive: true });

        const prev = this.querySelector('[data-prev]');
        const next = this.querySelector('[data-next]');
        if (prev) prev.addEventListener('click', () => this.goTo(this.index - 1));
        if (next) next.addEventListener('click', () => this.goTo(this.index + 1));
        this.dots.forEach((dot, i) => dot.addEventListener('click', () => this.goTo(i)));

        this.addEventListener('mouseenter', () => this.stop());
        this.addEventListener('mouseleave', () => this.start());
        this.addEventListener('focusin', () => this.stop());
        this.addEventListener('focusout', () => this.start());
        this.track.addEventListener('pointerdown', () => this.stop());

        this.setupAutoplay();
      }

      disconnectedCallback() {
        this.stop();
        if (this.observer) this.observer.disconnect();
      }

      goTo(i) {
        if (this.loop) {
          i = (i + this.count) % this.count;
        } else {
          i = Math.max(0, Math.min(i, this.count - 1));
        }
        // Read direction here, not in connectedCallback: getComputedStyle there forced a
        // full-page style/layout pass before the hero could paint.
        const rtl = getComputedStyle(this).direction === 'rtl';
        const offset = i * this.track.clientWidth * (rtl ? -1 : 1);
        this.track.scrollTo({ left: offset, behavior: this.reduced ? 'auto' : 'smooth' });
      }

      handleScroll() {
        if (this.raf) return;
        this.raf = requestAnimationFrame(() => {
          this.raf = null;
          const width = this.track.clientWidth || 1;
          const i = Math.round(Math.abs(this.track.scrollLeft) / width);
          if (i === this.index) return;
          this.index = i;
          this.dots.forEach((dot, n) => dot.setAttribute('aria-current', n === i ? 'true' : 'false'));
        });
      }

      setupAutoplay() {
        if (!this.hasAttribute('data-autoplay') || this.reduced) return;
        this.delay = (parseFloat(this.getAttribute('data-autoplay-speed')) || 5) * 1000;

        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => (entry.isIntersecting ? this.start() : this.stop()));
            },
            { threshold: 0.25 }
          );
          this.observer.observe(this);
        } else {
          this.start();
        }
      }

      start() {
        if (!this.delay || this.timer) return;
        this.timer = setInterval(() => this.goTo(this.index + 1), this.delay);
      }

      stop() {
        clearInterval(this.timer);
        this.timer = null;
      }
    }

    customElements.define('custom-slideshow', CustomSlideshow);

    // Theme editor: jump to a slide when the merchant selects it.
    document.addEventListener('shopify:block:select', (event) => {
      const slideshow = event.target.closest('custom-slideshow');
      if (!slideshow) return;
      slideshow.stop();
      const slide = event.target.closest('[data-slides] > *');
      const slides = Array.from(slideshow.querySelector('[data-slides]').children);
      const i = slides.indexOf(slide);
      if (i > -1) slideshow.goTo(i);
    });

    document.addEventListener('shopify:block:deselect', (event) => {
      const slideshow = event.target.closest('custom-slideshow');
      if (slideshow) slideshow.start();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-collection"] && !Shopify.designMode) return;
  try {
    
(function() {

  // ── Sort: auto-submit on change ──
  document.querySelectorAll('.toolbar-sort__select').forEach(function(select) {
    select.addEventListener('change', function() {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', this.value);
      window.location.href = url.toString();
    });
  });

  // ── Filter drawer toggle ──
  document.querySelectorAll('.toolbar-btn--filters').forEach(function(btn) {
    var drawerId = btn.getAttribute('aria-controls');
    var drawer   = document.getElementById(drawerId);
    if (!drawer) return;

    btn.addEventListener('click', function() {
      var isOpen = this.getAttribute('aria-expanded') === 'true';
      this.setAttribute('aria-expanded', String(!isOpen));
      drawer.setAttribute('aria-hidden', String(isOpen));
    });
  });

  // ── Filter group collapse toggles ──
  document.querySelectorAll('.cg-filter-group__toggle').forEach(function(toggle) {
    toggle.addEventListener('click', function() {
      var isExpanded = this.getAttribute('aria-expanded') === 'true';
      var panelId    = this.getAttribute('aria-controls');
      var panel      = document.getElementById(panelId);
      this.setAttribute('aria-expanded', String(!isExpanded));
      if (panel) {
        if (isExpanded) { panel.setAttribute('hidden', ''); }
        else            { panel.removeAttribute('hidden'); }
      }
    });
  });

// ── Collection description: collapsible if overflows ──
document.querySelectorAll('[data-collapsible]').forEach(function(wrap) {
  var content = wrap.querySelector('[data-collapsible-content]');
  var toggle  = wrap.querySelector('[data-collapsible-toggle]');
  if (!content || !toggle) return;

  var checkOverflow = function() {
    if (wrap.classList.contains('is-expanded')) return;
    var overflows = content.scrollHeight > content.clientHeight + 2;
    toggle.hidden = !overflows;
  };

  // Initial measurement — wait for fonts if the API is available,
  // otherwise fall back to a delayed check.
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(checkOverflow);
  } else {
    setTimeout(checkOverflow, 300);
  }
  // Also do an immediate check in case fonts are already loaded from cache
  requestAnimationFrame(checkOverflow);

  // Re-check whenever the container resizes (viewport, layout shifts)
  if ('ResizeObserver' in window) {
    var ro = new ResizeObserver(function() { checkOverflow(); });
    ro.observe(content);
  } else {
    window.addEventListener('resize', function() {
      clearTimeout(wrap._cgTimer);
      wrap._cgTimer = setTimeout(checkOverflow, 150);
    });
  }

  toggle.addEventListener('click', function() {
    var expanded = wrap.classList.toggle('is-expanded');
    toggle.setAttribute('aria-expanded', String(expanded));
  });
});

  // ── Filter form: submit navigates to filtered URL ──
  document.querySelectorAll('.cg-filter-form').forEach(function(form) {
    form.addEventListener('submit', function(e) {
      e.preventDefault();
      var params   = new URLSearchParams();
      var formData = new FormData(form);

      // Checked checkboxes
      form.querySelectorAll('input[type="checkbox"]:checked').forEach(function(cb) {
        params.append(cb.name, cb.value);
      });
      // Price inputs
      form.querySelectorAll('input[type="number"]').forEach(function(inp) {
        if (inp.value !== '') params.set(inp.name, inp.value);
      });
      // sort_by
      var sortInput = form.querySelector('input[name="sort_by"]');
      if (sortInput && sortInput.value) params.set('sort_by', sortInput.value);

      window.location.href = window.location.pathname + '?' + params.toString();
    });
  });

})();

  } catch(e) { console.error(e); }
})();
})();
